import api from './api';

export const purchaseService = {
  // Get all purchase invoices
  getAllPurchases: (params) => api.get('/purchases', { params }),

  // Get purchase invoice by ID
  getPurchaseById: (id) => api.get(`/purchases/${id}`),

  // Create purchase invoice
  createPurchase: (purchaseData) => api.post('/purchases', purchaseData),

  // Update purchase invoice
  updatePurchase: (id, purchaseData) => api.put(`/purchases/${id}`, purchaseData),

  // Process purchase invoice (create assets)
  processPurchase: (id, assetsData) => api.post(`/purchases/${id}/process`, assetsData),

  // Get purchase stats for dashboard
  getPurchaseStats: (params) => api.get('/purchases/stats', { params })
};

